module.exports = __webpack_public_path__ + "img/succeed.b88aa006.png";